import axios from "axios";

const http = axios.create({
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        // web
        'X-Request-Source': '1'
    }
});

export default http;
